module.exports = __webpack_public_path__ + "static/media/16.1df1548d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/16.jpg
// module id = 277
// module chunks = 0